export const STATUS_INFO = {
  pending: { title: 'Pending', color: 'orange' },
  approved: { title: 'Approved', color: 'green' },
  declined: { title: 'Declined', color: 'red' },
};

export const MONTH_FORMAT = 'YYYY/MM/DD';
